import { Sort } from '@infuse/api/common';
import { UiVariantNames } from '@infuse/ui/domain';

export const defaultSort = { key: 'id' };

export const lastSeenDescendingSort: Sort = {
  key: 'lastSeen',
  descending: true
};

export const getDefaultSortParams = (): Sort => {
  const { VITE_UI_VARIANT_CHARGING_STATION_PAGE_SORT_DEFAULT } = import.meta.env || '';

  switch (VITE_UI_VARIANT_CHARGING_STATION_PAGE_SORT_DEFAULT) {
    case UiVariantNames.CHARGING_STATION_SORT_LAST_SEEN_DESC:
      return lastSeenDescendingSort;
    default:
      return defaultSort;
  }
};
